import css from "@/app/(site)/battery-tips-and-tricks/battery-tips-and-tricks.module.scss";
import React from "react";

const OrangeArrow = ({ slug }: { slug: string }) => {
    const OrangeArrowFigure = ({ height }: { height: number }) => {
        return <div className={`absolute left-1/2 -translate-x-0.5 bottom-full ${slug === 'leaf' ? css['leaf-card-arrows'] : '-translate-y-[30px]'}`}>
            <div className="bg-[#F26922] p-[3px] rounded-full" />
            <div className="bg-[#F26922] w-[2px] mx-auto" style={{ height: `${height}px` }} />
        </div>
    }

    const heightsForSlug = {
        'root-root-xl': [208],
        'leaf': [120, 60],
    };

    const heightSequence = Object.keys(heightsForSlug).includes(slug)
        ? heightsForSlug[slug as 'root-root-xl' | 'leaf'] : [56];

    return <div className='flex justify-around'>
        {
            heightSequence.map((height, idx) => (
                <div key={`${height}-${idx}`} className="relative">
                    <OrangeArrowFigure height={height} />
                </div>
            ))
        }
    </div>
}

export default OrangeArrow;
